import classNames from "classnames";

import Pill from "../../../common/Pill";
import { ITEM_ACCEPTED_STATUS } from "../../constants";
import styles from "./status.module.scss";

export function ItemAcceptedStatus() {
  return (
    <Pill
      styleName="accepted"
      Lefticon={<img src={"../../../assets/images/svg/done.svg"} />}>
      <p className={classNames(styles.text, "p2")}>{ITEM_ACCEPTED_STATUS}</p>
    </Pill>
  );
}
